var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagingCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 73,
    viewBox: "0 0 90 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5749_23007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3 58.1C76.2058 58.1 89.1 45.2058 89.1 29.3C89.1 13.3942 76.2058 0.5 60.3 0.5C44.3942 0.5 31.5 13.3942 31.5 29.3C31.5 45.2058 44.3942 58.1 60.3 58.1Z",
    fill: "#00274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2953 47.8992C70.5678 47.8992 78.8953 39.5717 78.8953 29.2992C78.8953 19.0267 70.5678 10.6992 60.2953 10.6992C50.0228 10.6992 41.6953 19.0267 41.6953 29.2992C41.6953 39.5717 50.0228 47.8992 60.2953 47.8992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7016 40.5996H20.1016V54.2996H27.0016C27.4016 54.2996 27.7016 53.9996 27.7016 53.5996V40.5996Z",
    fill: "#40708F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 40.5996H10.5V70.8996H20.2V40.5996Z",
    fill: "#00274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1969 70.4004H3.89688C3.29688 70.4004 2.79688 70.9004 2.79688 71.5004C2.79688 72.0004 3.29688 72.5004 3.89688 72.5004H86.2969C86.8969 72.5004 87.3969 72.0004 87.3969 71.4004C87.2969 70.9004 86.7969 70.4004 86.1969 70.4004Z",
    fill: "#00274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4984 40.8997C7.59844 40.8997 4.79844 40.7997 1.89844 40.8997C1.09844 40.8997 0.898438 40.6997 0.898438 39.8997C0.998438 37.9997 0.998438 36.0997 0.898438 34.2997C0.898438 33.4997 1.09844 33.1997 1.89844 33.1997C11.3984 33.1997 78.0984 32.8997 78.4984 33.1997C77.8984 36.0997 76.6984 38.6997 74.7984 40.9997C73.7984 40.8997 10.7984 41.1997 10.4984 40.8997Z",
    fill: "#63C0DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5749_23007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.2,
    height: 72,
    fill: "white",
    transform: "translate(0.898438 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagingCenter);
export default __webpack_public_path__ + "static/media/imaging-center.dcd67a97756e869c629e2efeb965f077.svg";
export { ForwardRef as ReactComponent };